import React, { useEffect, useContext } from 'react';
import { useState } from 'react';

import SmallProductCard from './SmallProductCard.jsx';

import TranslationsContext from '../TranslationsContext';

const SubscriptionList = ({ subscriptionProducts, subscriptionsDetails, depositedData, setDepositedData, currentDog, subscriptionDisplay, formatMoney }) => {
	const t = useContext(TranslationsContext);
	const [selectedSubscription, setSelectedSubscription] = useState(depositedData[currentDog].subscription.title || '');
	const [cardsMarkup, setCardsMarkup] = useState('');
	const [helper, setHelper] = useState(false);

	const selectedSubscriptionGroup = subscriptionsDetails.find((el) => el.selected === true);

	const populateDropdown = (param) => {
		if (!param?.subscription_plans) return [];

		const markup = param.subscription_plans.map((item, index) => {
			return (
				<li
					key={index}
					className={`${selectedSubscription === item.title ? 'is-selected' : ''}`}
					onClick={(e) => {
						const target = e.target instanceof Element ? e.target : null;

						if (!target) return;

						if (target.classList.contains('is-selected')) {
							setSelectedSubscription('');
							setDepositedData((prevState) => {
								prevState[currentDog] = {
									...prevState[currentDog],
									subscription: {},
									subscription_total_price: 0,
								};
								return prevState;
							});
						} else {
							setSelectedSubscription(item.title);
							setDepositedData((prevState) => {
								prevState[currentDog] = {
									...prevState[currentDog],
									subscription: item,
									subscription_total_price: Object.keys(subscriptionProducts)
										.map((product) => {
											if (depositedData[currentDog].products.includes(product)) {
												return subscriptionProducts[product].fetchData.price * item.products[product].custom_bottles;
											} else {
												return 0;
											}
										})
										.reduce((a, b) => a + b, 0),
								};
								return prevState;
							});
						}
					}}
				>
					{item.title}
					{item.recommended === 'true' && <span className="checkbox--highlight">{t('recommended')}</span>}
				</li>
			);
		});

		return markup;
	};

	const populateRadio = (param) => {
		if (!param?.subscription_plans) return [];

		const CustomRadioButton = ({ label, selected, onSelect, recommended }) => (
			<li>
				<button
					className={`flex-container align-center-middle flex-dir-row ${recommended ? 'checkbox--recommended' : ''} ${
						selected ? 'is-selected' : ''
					}`}
					onClick={onSelect}
				>
					{label}
				</button>
			</li>
		);

		const CustomRadioCheckbox = ({ index, label, selected, onSelect, recommended }) => (
			<li className="flex-container flex-dir-row align-middle">
				<input type="radio" id={`radio-${index}`} name="subscription" value={label} checked={selected} onChange={onSelect} />
				<label htmlFor={`radio-${index}`}>
					{label} {recommended && <span className="checkbox--highlight">{t('recommended_for_size')}</span>}
				</label>
			</li>
		);

		const markup = param.subscription_plans.map((item, index) => {
			if (subscriptionDisplay === 'radio_buttons') {
				return (
					<CustomRadioButton
						key={index}
						label={item.title}
						selected={selectedSubscription === item.title}
						recommended={item.recommended === 'true'}
						onSelect={(e) => {
							if (e.target.classList.contains('is-selected')) {
								setSelectedSubscription('');
								setDepositedData((prevState) => {
									prevState[currentDog] = {
										...prevState[currentDog],
										subscription: {},
										subscription_total_price: 0,
									};
									return prevState;
								});
							} else {
								setSelectedSubscription(item.title);
								setDepositedData((prevState) => {
									prevState[currentDog] = {
										...prevState[currentDog],
										subscription: item,
										subscription_total_price: Object.keys(subscriptionProducts)
											.map((product) => {
												if (depositedData[currentDog].products.includes(product)) {
													return subscriptionProducts[product].fetchData.price * item.products[product].custom_bottles;
												} else {
													return 0;
												}
											})
											.reduce((a, b) => a + b, 0),
									};
									return prevState;
								});
							}
						}}
					/>
				);
			} else {
				return (
					<CustomRadioCheckbox
						key={index}
						index={index}
						label={item.title}
						recommended={item.recommended === 'true'}
						selected={selectedSubscription === item.title}
						onSelect={(e) => {
							if (e.target.checked) {
								setSelectedSubscription(item.title);
								setDepositedData((prevState) => {
									prevState[currentDog] = {
										...prevState[currentDog],
										subscription: item,
										subscription_total_price: Object.keys(subscriptionProducts)
											.map((product) => {
												if (depositedData[currentDog].products.includes(product)) {
													return subscriptionProducts[product].fetchData.price * item.products[product].custom_bottles;
												} else {
													return 0;
												}
											})
											.reduce((a, b) => a + b, 0),
									};
									return prevState;
								});
							}
						}}
					/>
				);
			}
		});

		return markup;
	};

	const adjustSubscriptionQuantities = (product, quantity) => {
		const copiedDepositedDataCurrentDog = { ...depositedData[currentDog] };
		copiedDepositedDataCurrentDog.subscription.products[product].custom_bottles = quantity;
		copiedDepositedDataCurrentDog.subscription_total_price = Object.keys(subscriptionProducts)
			.map((product) => {
				if (copiedDepositedDataCurrentDog.products.includes(product)) {
					return (
						subscriptionProducts[product].fetchData.price * copiedDepositedDataCurrentDog.subscription.products[product].custom_bottles
					);
				} else {
					return 0;
				}
			})
			.reduce((a, b) => a + b, 0);

		setDepositedData((prevState) => {
			prevState[currentDog] = {
				...copiedDepositedDataCurrentDog,
			};
			return prevState;
		});

		// console.log("schimb helper")

		setHelper(!helper);
	};

	const generateCardsMarkup = () => {
		if (!selectedSubscriptionGroup?.subscription_plans) return null;

		const selectedSubscriptionDetails = selectedSubscriptionGroup.subscription_plans.find((item) => item.title === selectedSubscription);

		// Temporary fix for livertune and jointbutter
		// if (selectedSubscriptionDetails) {
		// 	selectedSubscriptionDetails.products['livertune-supplement'] = {
		// 		bottles: 2,
		// 		remaining_days: '+5',
		// 	};

		// 	selectedSubscriptionDetails.products['jointbutter-for-dogs'] = {
		// 		bottles: 1,
		// 		remaining_days: '+10',
		// 	};

		// 	selectedSubscriptionDetails.products['jointpowder-for-dogs'] = {
		// 		bottles: 2,
		// 		remaining_days: '+6',
		// 	};
		// }

		// subscriptionFullPrice = selectedSubscriptionDetails
		// 	? Object.keys(subscriptionProducts)
		// 			.map((product, index) => {
		// 				if (depositedData[currentDog].products.includes(product)) {
		// 					return subscriptionProducts[product].fetchData.price * selectedSubscriptionDetails.products[product].bottles;
		// 				} else {
		// 					return 0;
		// 				}
		// 			})
		// 			.reduce((a, b) => a + b, 0)
		// 	: 0;

		const allCardsMarkup = Object.keys(subscriptionProducts).map((product, index) => {
			if (depositedData[currentDog].products.includes(product)) {
				const productPrice = subscriptionProducts[product].fetchData.price;
				const productDiscountedPrice = (productPrice * (100 - depositedData[currentDog].discount)) / 100 / 100;
				return (
					<SmallProductCard
						index={index}
						key={index}
						product={product}
						selectedSubscriptionDetails={selectedSubscriptionDetails}
						subscriptionProducts={subscriptionProducts}
						productPrice={productPrice}
						productDiscountedPrice={productDiscountedPrice}
						adjustSubscriptionQuantities={adjustSubscriptionQuantities}
						formatMoney={formatMoney}
					/>
				);
			}
		});

		return (
			<>
				{allCardsMarkup}
				{selectedSubscriptionDetails && depositedData[currentDog].subscription_total_price != 0 && (
					<div className="columns flex-container flex-dir-column text-right">
						<div className="cards__subscription-summary flex-container flex-dir-column">
							<p className="subscription-summary__full">
								{t('total_price')} {formatMoney(depositedData[currentDog].subscription_total_price / 100)}
							</p>
							<p className="subscription-summary__discounted">
								{t('your_savings_label')}{' '}
								{formatMoney(
									((depositedData[currentDog].discount / 100) * depositedData[currentDog].subscription_total_price) / 100
								)}
							</p>
							<p className="subscription-summary__discounted">
								{t('your_special_price')}{' '}
								{formatMoney(
									(depositedData[currentDog].subscription_total_price -
										(depositedData[currentDog].discount / 100) * depositedData[currentDog].subscription_total_price) /
									100
								)}
							</p>
						</div>
					</div>
				)}
			</>
		);
	};

	useEffect(() => {
		// console.log("aici s-a apelataaaa")
		setCardsMarkup(generateCardsMarkup());
	}, [selectedSubscription, depositedData[currentDog], helper]);

	return (
		<div
			className="column small-12"
			onClick={(e) => {
				const details = [...document.querySelectorAll('details')];
				if (!details.some((f) => f.contains(e.target instanceof Node ? e.target : null))) {
					details.forEach((f) => f.removeAttribute('open'));
				} else {
					details.forEach((f) => (!f.contains(e.target instanceof Node ? e.target : null) ? f.removeAttribute('open') : ''));
				}
			}}
		>
			<div className="row small-12 align-middle">
				<div className="subscription-list__main-label field columns small-12 medium-12 flex-container flex-dir-row align-middle flex-wrap">
					<span className="field__number">3</span>
					<label className={`${subscriptionDisplay === 'dropdown' ? 'full-width' : ''}`}>
						<span>{t('select_frequency_label')}</span>
					</label>
					{subscriptionDisplay === 'dropdown' ? (
						<>
							<details className="subscription-list__dropdown">
								<summary>{selectedSubscription != '' ? selectedSubscription : t('select_subscription_placeholder')}</summary>
								<ul>{populateDropdown(selectedSubscriptionGroup)}</ul>
							</details>
							<p className="field__disclaimer">{t('frequency_disclaimer')}</p>
						</>
					) : (
						<>
							<ul className={`subscription-list__radios ${subscriptionDisplay} flex-container flex-dir-row flex-wrap`}>
								{populateRadio(selectedSubscriptionGroup)}
							</ul>
							<p className="field__disclaimer">{t('frequency_disclaimer')}</p>
						</>
					)}
				</div>
			</div>
			<div className="row small-12 align-center section-spacing-mobile">
				<h3 className="text-center no-margin">{t('adjust_order_below')}</h3>
			</div>
			<div className="row extra-small-up-1 small-up-2 medium-up-2 large-up-2 subscription-list__cards">
				{subscriptionProducts && cardsMarkup}
			</div>
		</div>
	);
};

export default SubscriptionList;
